/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let ChartTrendingO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M745.32864 155.27936c-15.166464 0-27.462656-12.295168-27.462656-27.46368 0-15.166464 12.296192-27.462656 27.46368-27.462656h109.85472c15.166464 0 27.46368 12.296192 27.46368 27.46368V237.6704c0 15.166464-12.297216 27.46368-27.46368 27.46368-15.168512 0-27.46368-12.297216-27.46368-27.46368v-82.39104h-82.39104zM196.06016 594.697216v274.635776h109.85472V594.696192h-109.85472z m0-54.92736h109.85472c30.334976 0 54.926336 24.592384 54.926336 54.92736v274.635776c0 30.334976-24.59136 54.92736-54.92736 54.92736h-109.85472c-30.334976 0-54.926336-24.592384-54.926336-54.92736V594.696192c0-30.334976 24.59136-54.92736 54.92736-54.92736z m274.634752-54.926336v384.489472h109.85472V484.842496h-109.85472z m0-54.92736h109.85472c30.334976 0 54.92736 24.592384 54.92736 54.92736v384.489472c0 30.334976-24.592384 54.92736-54.92736 54.92736h-109.85472c-30.334976 0-54.92736-24.592384-54.92736-54.92736V484.842496c0-30.334976 24.592384-54.92736 54.92736-54.92736z m274.635776-54.92736v494.344192h109.85472V374.9888H745.32864z m109.85472-54.92736c30.334976 0 54.926336 24.592384 54.926336 54.92736v494.344192c0 30.334976-24.59136 54.92736-54.92736 54.92736H745.32864c-30.334976 0-54.926336-24.592384-54.926336-54.92736V374.9888c0-30.336 24.59136-54.92736 54.92736-54.92736h109.85472z m21.444608-209.399808c9.475072 11.843584 7.555072 29.126656-4.288512 38.601728l-286.18752 228.950016-167.047168-54.150144-263.960576 156.606464c-13.044736 7.739392-29.893632 3.438592-37.632-9.60512-7.740416-13.04576-3.439616-29.894656 9.60512-37.634048l285.309952-169.27232 162.515968 52.680704 263.083008-210.466816c11.843584-9.475072 29.126656-7.555072 38.601728 4.289536z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

ChartTrendingO.defaultProps = {
  size: 18,
};

ChartTrendingO = React.memo ? React.memo(ChartTrendingO) : ChartTrendingO;

export default ChartTrendingO;
